export default "__VITE_ASSET__CiCWpYlG__"